import { ItemList } from '../../commons/components/ItemList';
import {
  SURVEY_ITEM_FINANCIAL_ANALYSIS,
  SURVEY_ITEM_INTRO,
  SURVEY_ITEM_REVIEW,
  SURVEY_ITEM_SECTION,
  SURVEY_ITEM_VARIABLES,
  SurveyItemViewModel,
} from '../types';
import {
  BookIcon,
  BulbIcon,
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  BarsIcon,
  StarIcon,
} from '../../assets/icons';
import { useCallback } from 'react';
import { ItemListProps } from '../../commons/components/ItemListAndDetails';
import { StyleVariables } from '../../commons/styleConstants';
import { isSurveySectionDone } from '../utils';

export const SurveyItemList = (props: ItemListProps<SurveyItemViewModel>) => {
  const {
    items,
    itemsLoadingComponent,
    selectedItem,
    onItemSelected,
    idGetter,
    nameGetter,
    categoryGetter,
  } = props;
  const iconComponent = useCallback((props: { item: SurveyItemViewModel; className: string }) => {
    const { item, className } = props;
    switch (item.type) {
      case SURVEY_ITEM_INTRO:
        return <BulbIcon className={className} />;
      case SURVEY_ITEM_VARIABLES:
        return <StarIcon className={className} style={{ fill: StyleVariables.neutral500 }} />;
      case SURVEY_ITEM_SECTION:
        return isSurveySectionDone(item) ? (
          <CheckboxCheckedIcon className={className} />
        ) : (
          <CheckboxUncheckedIcon className={className} />
        );
      case SURVEY_ITEM_FINANCIAL_ANALYSIS:
        return <BarsIcon className={className} />;
      case SURVEY_ITEM_REVIEW:
        return <BookIcon className={props.className} style={{ fill: StyleVariables.neutral500 }} />;
    }
  }, []);

  const tickedGetter = useCallback(
    (x: SurveyItemViewModel) => (x.type === SURVEY_ITEM_SECTION ? !!isSurveySectionDone(x) : false),
    []
  );

  return (
    <ItemList
      items={items}
      itemsLoadingComponent={itemsLoadingComponent}
      selectedItem={selectedItem}
      onItemSelected={onItemSelected}
      idGetter={idGetter}
      nameGetter={nameGetter}
      iconComponent={iconComponent}
      categoryGetter={categoryGetter}
      tickedGetter={tickedGetter}
      noMenu={true}
    />
  );
};
